import uploadFile from './upload-file.vue';
export default uploadFile;
